// ===== PROJECT SPELLING ALIASES — the client twin of crm-aro-backend/project-aliases.js =====
// Byte-identical body (verify-project-aliases.js compares the two after stripping
// comments and export syntax). Read the backend file for the rules and the owner
// decisions behind every pair; change BOTH files together.


export var PROJECT_ALIASES = {
  // ── A: punctuation twins ──
  "D.O.S.E":               ["Dose"],                                   // DOSE / dose / D.o.s.e fold here by key
  "Mountain View":         ["Mv1.1", "M.V 1.1", "Mv 1.1", "Mv1 1", "Mv", "M. V"],
  "Royal's":               ["Royals", "Royal, s"],                     // "Royal" is a DIFFERENT project — not listed, never folded
  "Butterfly":             ["Butterfly 🦋"],
  "Al-jar":                ["Aljar"],
  "X mall":                ["X-mall"],
  "UE":                    ["U & E"],
  "Marseilia":             ["Marseilia youd", "Marseilia you’d", "Marseilia you'd", "Marseilia,Youd", "Marseilia Dose", "Marseilia, Dose"],   // first project written wins
  "Youd":                  ["Youd marsilia", "Youd ,,marsilia"],
  // ── C: compound comma values — the first project written wins ──
  "Naia Bay":              ["NaiaBay", "Naia Bay ,Dose", "Naia Bay,Dose"],
  "Acasa Mia":             ["Acasamia", "Acasa mia , mayan", "Acasa Mia, mayan"],
  "Sodic":                 ["Sodic , solana", "Sodic, solana"],
  "Creek town":            ["Creek town , trio", "Creek town, trio"],
  "Queen":                 ["Queen , isola", "Queen, isola"],
  // ── B: spacing twins, owner-named canonicals ──
  "Hyde Park":             ["Hydepark"],                               // the company; kept apart from One Hyde Park
  "One Hyde Park":         ["One Hydepark"],
  "Mayan ElShrouk":        ["Mayan elsherouk", "Mayan el sherouk"],
  "Ras El Hikma":          ["Ras Elhikma"],
  "Hacienda Ras El Hikma": ["Hacienda ras elhikma", "Hacienda raselhekma", "Hacienda ras elhekma"],
  // ── B: spacing twins, most-frequent spelling wins, written in the title-case rule (owner 2026-10-29 step 2) ──
  "Cali Coast":            ["Calicoast"],                              // "Cali coast" folds here by key
  "Seashore":              ["Sea shore"],
  "West View":             ["Westview"],
  "Silversands":           ["Silver sands"],
  "Lavista City":          ["La vista city"],
  "Eko Mena":              ["Ekomena"],
  "Degla Landmark":        ["Degla land mark", "Deglalandmark"],
  "مارسيليا beach 5":      ["مارسيليا beach5"],
  "Sun Capital":           ["Suncapital"],
  "Mayan New Cairo":       ["Mayan newcairo"],
  "Water Way":             ["Waterway"],
  "Hay Elashgar":          ["Hay el ashgar"],
  "Vx90":                  ["Vx 90"],
  "Alam Elroum":           ["Alam el roum"],
  "Ecomena":               ["eco mena"],
  "Alashraf":              ["Al ashraf"],
  "Eco Mina":              ["ecomina"],                                // 1:1 tie → code-point order (the server's collapse() rule)
  "Hyde Park New Cairo":   ["Hydepark new Cairo"],                     // 1:1 tie → code-point order
  "Mar Bay":               ["Marbay"]                                  // 1:1 tie → code-point order
};

export var DOTS_ONLY_RE = /^\.+$/;

export function projectFoldKey(raw) {
  return String(raw == null ? "" : raw).trim().replace(/\s+/g, " ").toLowerCase();
}

var ALIAS_INDEX = (function () {
  var idx = {};
  Object.keys(PROJECT_ALIASES).forEach(function (canonical) {
    idx[projectFoldKey(canonical)] = canonical;
    PROJECT_ALIASES[canonical].forEach(function (variant) { idx[projectFoldKey(variant)] = canonical; });
  });
  return idx;
})();

// A word is a run of letters/digits with internal apostrophes or dots ("Royal's",
// "D.O.S.E"); hyphens, commas and spaces separate words.
var WORD_RE = /[\p{L}\p{N}][\p{L}\p{N}'\u2019.]*/gu;
export function titleCaseWords(raw) {
  if (raw == null) return raw;
  // Underscores are word breaks typed as code ("twin_house", "standalone_55m" —
  // owner 2026-10-29): they become spaces BEFORE the words are cased, so the
  // value reads "Twin House" / "Standalone 55m" and the fold key matches a
  // hand-typed "twin house". Nothing in the codebase matches the underscore
  // codes (verified before the backfill), so the only reader is a human.
  // Leading/trailing underscores ("شقة_") are dropped rather than turned into
  // stray spaces; a run of underscores is one space.
  return String(raw).replace(/^_+|_+$/g, "").replace(/_+/g, " ").replace(WORD_RE, function (w) {
    if (/\p{N}/u.test(w)) return w;                                             // alphanumerics stay as-is
    if (w.length > 1 && w === w.toUpperCase() && w !== w.toLowerCase()) return w;  // acronyms (ALL CAPS) stay as-is
    var first = w.charAt(0);
    return first.toUpperCase() + w.slice(1);                                    // Arabic has no case: unchanged
  });
}

export function canonicalProjectName(raw) {
  if (raw == null) return raw;
  var s = String(raw), t = s.trim();
  if (!t) return s;
  if (DOTS_ONLY_RE.test(t)) return "";
  var canonical = ALIAS_INDEX[projectFoldKey(t)];
  return canonical === undefined ? titleCaseWords(s) : canonical;
}

